<script>
import SectionTeam from './components/SectionTeam'
import SectionOrganization from './components/SectionOrganization'
import AboutLayout from './components/MenuList'
export default {
  page() {
    return {
      title: `經營團隊 | 關於零壹`,
    }
  },
  components: {
    AboutLayout,
    SectionTeam,
    SectionOrganization,
  },
  props: {
    aboutTeam: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {}
  },
}
</script>
<template>
  <AboutLayout>
    <SectionTeam v-if="aboutTeam && !!aboutTeam.member.length" :about-team-member="aboutTeam.member"></SectionTeam>
    <SectionOrganization v-if="aboutTeam && aboutTeam['structure-image']" :image="aboutTeam['structure-image']"></SectionOrganization>
  </AboutLayout>
</template>
<style lang="scss" module>
</style>
